import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { QUEUE_IDS } from 'customer-data-objects/task/TaskPropertyNames';
import { TruncateDiv } from 'framework-data-table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getIn from 'transmute/getIn';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useTaskQueue } from '../../hooks/useTaskQueues';
import { EmptyStateCell } from './EmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskQueueCell = ({
  original: task
}) => {
  const queueId = getProperty(task, QUEUE_IDS);
  const {
    loading,
    queue
  } = useTaskQueue(queueId);
  if (!queueId) {
    return /*#__PURE__*/_jsx(EmptyStateCell, {});
  }
  if (loading) {
    return /*#__PURE__*/_jsx("span", {});
  } else if (!queue) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tasks-table.cells.queue.noPermissionsTooltip"
      }),
      children: /*#__PURE__*/_jsx("span", {
        children: "--"
      })
    });
  }
  return /*#__PURE__*/_jsx(TruncateDiv, {
    children: getIn(['definition', 'name'], queue)
  });
};
export default TaskQueueCell;